// Messages for operator/companies/AddUserModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.add_user.role.company_admin': 'Company admin',
  'operator.add_user.role.member': 'Member',
  'operator.add_user.title': 'Invite portal user',
  'operator.add_user.cancel': 'Cancel',
  'operator.add_user.send': 'Send invite',
  'operator.add_user.blurb':
    "They'll get a one-time link to set a password and sign in to the customer portal.",
  'operator.add_user.email': 'Email',
  'operator.add_user.email_placeholder': 'name@company.com',
  'operator.add_user.role': 'Role',
}

export const zhTW = {
  'operator.add_user.role.company_admin': '公司管理員',
  'operator.add_user.role.member': '成員',
  'operator.add_user.title': '邀請入口使用者',
  'operator.add_user.cancel': '取消',
  'operator.add_user.send': '傳送邀請',
  'operator.add_user.blurb': '他們將收到一次性連結以設定密碼並登入客戶入口。',
  'operator.add_user.email': '電子郵件',
  'operator.add_user.email_placeholder': 'name@company.com',
  'operator.add_user.role': '角色',
}
